import { NavigateFunction } from 'react-router-dom';
import authService from '../services/authService';

/**
 * Checks if the user is authenticated and redirects to the registration page if not
 * 
 * @param navigate - The navigate function from useNavigate hook
 * @param returnPath - Optional path to return to after login
 * @returns - Boolean indicating if user is authenticated
 */
export const requireAuth = (navigate: NavigateFunction, returnPath?: string): boolean => {
  if (!authService.isAuthenticated()) {
    // Navigate to the registration page with the return path
    navigate('/register', {
      state: { returnTo: returnPath || window.location.pathname }
    });
    
    return false;
  }
  
  return true;
}; 